import React from 'react';
import TextCard from '~/components/Dynamic/TextCard';
import logoWhite from '~/images/logo-white.svg';
import TL from '~/images/join/tl.png';
import TR from '~/images/join/tr.png';
import BL from '~/images/join/bl.png';
import BR from '~/images/join/br.png';

import { motion, AnimatePresence } from 'framer-motion';

export default function JoinConfirmation({ confirmation }) {
  return (
    <AnimatePresence>
      <div className="text-white bg-black pt-12">
        <div className="max-w-xl mx-auto relative">
          <motion.img
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { duration: 0.85, delay: 0 } }}
            exit={{ scale: 0, opacity: 0 }}
            src={TL}
            className="absolute top-[-20%] right-[100%]"
            alt=""
          />
          <motion.img
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { duration: 0.85, delay: 0.2 } }}
            exit={{ scale: 0, opacity: 0 }}
            src={TR}
            className="absolute top-[-20%] left-[100%]"
            alt=""
          />
          <motion.img
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { duration: 0.85, delay: 0.1 } }}
            exit={{ scale: 0, opacity: 0 }}
            src={BL}
            className="absolute bottom-[-20%] right-[100%]"
            alt=""
          />
          <motion.img
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1, transition: { duration: 0.85, delay: 0.3 } }}
            exit={{ scale: 0, opacity: 0 }}
            src={BR}
            className="absolute bottom-[-20%] left-[100%]"
            alt=""
          />

          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.85, delay: 0.5 } }}
            exit={{ opacity: 0 }}
            className="mx-auto mb-16"
            src={logoWhite}
            alt="Boom logo"
          />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1, delay: 0.8 } }}
            exit={{ opacity: 0 }}
          >
            <TextCard
              blok={{
                ...confirmation[0],
                textAlign: 'center',
                contentClass: 'max-w-sm',
              }}
            />
          </motion.div>
        </div>
      </div>
    </AnimatePresence>
  );
}
